import React from 'react';
import { Query } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Styled from 'styled';

import SVGIconView from 'lib/images/svg-icon-view';
import LoadingProgress from 'lib/react-router/loading-progress';

import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import IconAddToGroup from 'four-nets/icons/svg/icon_add-to-group.svg';
import ErrorPage from 'four-nets/errors/error-page';

import Group from './group/group';
import defaultStyles from './my-groups.scss';
import SkeletonGroup from './skeleton-group/skeleton-group';
import usersGroupsQuery, { UsersGroupsQuery, UsersGroupsQueryVariables } from './my-groups.graphql';

export interface Props {
    styles: typeof defaultStyles;
    all?: boolean;
}

class MyGroups extends React.PureComponent<Props> {
    render() {
        const { styles, all } = this.props;

        return (
            <ViewerConsumer>
                {({ viewer }) =>
                    !viewer ? null : (
                        <div className={styles.container}>
                            {all ? null : (
                                <div className={styles.header}>
                                    <Link to='/list-of-groups/mine/' className={styles.link}>
                                        <h2 className={styles.title}>
                                            <FormattedMessage id='GROUPS_MY_GROUPS' />
                                        </h2>
                                    </Link>
                                    <Link to='/new-group/' className={styles.addToGroupLink}>
                                        <SVGIconView className={styles.buttonImage} src={IconAddToGroup} />
                                        <FormattedMessage id='CREATE_NEW' />
                                    </Link>
                                </div>
                            )}
                            <Query<UsersGroupsQuery, UsersGroupsQueryVariables>
                                query={usersGroupsQuery}
                                variables={{
                                    first: all ? undefined : 10,
                                }}
                            >
                                {({ loading, data, error }) => (
                                    <LoadingProgress loading={loading}>
                                        <ErrorPage error={error}>
                                            <ul className={styles.groups}>
                                                {loading ? (
                                                    [1, 2, 3, 4].map(index => (
                                                        <li className={styles.group} key={index}>
                                                            <SkeletonGroup key={index} />
                                                        </li>
                                                    ))
                                                ) : data &&
                                                  data.myGroups &&
                                                  data.myGroups.edges &&
                                                  data.myGroups.edges.length ? (
                                                    data.myGroups.edges.map((edge, index) =>
                                                        edge && edge.node ? (
                                                            <li className={styles.group} key={index}>
                                                                <Group {...edge.node} key={index} />
                                                            </li>
                                                        ) : null
                                                    )
                                                ) : (
                                                    <div className={styles.empty}>
                                                        <FormattedMessage
                                                            id='NO_GROUPS_WERE_FOUND._MAYBE_YOU_SHOULD_CREATE_ONE.'
                                                            values={{ gender: viewer.sex === 1 ? 'f' : 'm' }}
                                                        />
                                                    </div>
                                                )}
                                            </ul>
                                        </ErrorPage>
                                    </LoadingProgress>
                                )}
                            </Query>
                        </div>
                    )
                }
            </ViewerConsumer>
        );
    }
}

export default Styled(defaultStyles)(MyGroups);
